import {useAppStore} from '../appStore'

export const userActions = {
  // setters for React Query sync (called from BaseLayout)
  useSetCurrentUser: () => useAppStore(s => s.setCurrentUser),
  useSetWorkforces: () => useAppStore(s => s.setWorkforces),
  useSetProductSwitcher: () => useAppStore(s => s.setProductSwitcher),
  useSetPanelTheme: () => useAppStore(s => s.setPanelTheme),

  // pure UI setters
  useChangeWorkforceName: () => useAppStore(s => s.changeWorkforceName),
  useSortWorkforces: () => useAppStore(s => s.sortWorkforces),
  useSetSelectWorkforce: () => useAppStore(s => s.setSelectWorkforce),
  useSetSelectedLanguage: () => useAppStore(s => s.setSelectedLanguage),
  useSetPrevPath: () => useAppStore(s => s.setPrevPath),
} as const
